import React, {Component} from "react";
import axios from "axios";
import {createRoot} from 'react-dom/client';
import "../../sass/_document.scss";
import Player from "../components/Player/Player";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import Grid from "../components/Grid/Grid";
import Common from "../utils/common";
import AmbassadorHelper from "../utils/AmbassadorHelper";
import store from "../store/store";
import * as actionType from "../store/actions";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import theme from "../../sass/variables.json";
import {Box, Container, Typography} from "@mui/material";
import ThemeProviderWrapper from "../hoc/ThemeProviderWrapper";

const {asset} = ConfigurationHelper.getGlobalConfiguration().channelVideosData;

class Video extends Component {
    state = {
        breadcrumbsList: [],
        totalVideos: 0
    }
    componentDidMount() {
        store.subscribe(this.updateAmbassador);
        Common.setCustomCookie(TVSite?.channelVideosData?.asset?.owner);
    }

    updateAmbassador = () => {
        const storeState = store.getState();
        if (storeState.event === actionType.UPDATE_BREADCRUMBS) {
            const breadCrumbs = [];
            if (storeState && storeState.ambassador && ConfigurationHelper.isAmbassadorProgramEnabled()) {
                breadCrumbs.push({
                    name: AmbassadorHelper.getDisplayNameFromApi(storeState.ambassador),
                    url: TVSite.sub_folder + "/a/" + storeState.ambassador.user_slug + "/" + storeState.ambassador.user_id,
                    highlightMobile: true
                });
            } else if (!ConfigurationHelper.isAmbassadorProgramEnabled()) {
                const entityType = storeState.asset.entityType === 7 ? "Photo" : "Video";
                breadCrumbs.push({
                    name: entityType,
                    highlightMobile: false,
                    hideItemOnMobile: true,
                    keepOnMobile: false
                });
            }
            if (storeState && storeState.asset) {
                breadCrumbs.push({
                    name: storeState.asset.title,
                    url: Common.getVideoPageUrl(storeState.asset),
                    active: true,
                    hideItemOnMobile: ConfigurationHelper.isAmbassadorProgramEnabled()
                });
            }
            this.setState({
                breadcrumbsList: breadCrumbs
            });
        }
    }

    fetchAssets = async ({ page, filters }) => {
        const { creator_id } = filters;
        let filter = '{attribute:{code: "show_on_grid" , value: "yes"}}';
        if (creator_id) {
            filter = `{attribute:{code: "show_on_storefront" , value: "yes"}}, {creator_id: ${creator_id}}`;
        }
        const requestQuery = `{
            content(page: ${page}, per_page: 12, filter: {AND: [${filter}]}) {
                total
                items {
                    content_id
                    title
                    page_url
                    description
                    creator {
                        creator_id
                        employee_id
                        uri_stem
                        thumbnail
                        first_name
                        full_name
                        last_name
                        region {
                            name
                        }
                        store {
                            name
                            store_number
                        }
                    }
                    products {
                        product_id
                        image
                        price
                        sale_price
                        title
                        link
                    }
                    attributes {
                        code
                        value
                    }
                    content_type
                    creation_date
                    asset {
                        asset_type
                        video {
                            thumbnails {
                                width
                                height
                                url
                            }
                        }
                        photo {
                            thumbnails {
                                url
                                width
                                height
                            }
                        }
                    }
                }
            }
        }`;
        const apiUrl = ConfigurationHelper.getContentSearchUrl();
        const response = await axios.post(apiUrl, { query: requestQuery }, { withCredentials: true });
        this.setState({ totalVideos: response.data.data.content.total });
        return response.data.data.content.items.map(item => {
            const attribute = item.attributes?.find?.(f => f.code === "category");
            const category = attribute?.value[0] || ""; 
            return {...item,
                title: item.title,
                user_id: item?.creator?.creator_id,
                description: item.description,
                id: item.content_id,
                category: category,
                entityType: item.content_type === "video" ? 1 : 7,
                owner: item.creator,
            };
        });
    };

    render() {
        const {breadcrumbsList, totalVideos} = this.state;
        const creator_id = TVSite?.channelVideosData?.asset?.owner?.id || null;
        return (
            <div className={"document-body "+theme.hub_wrapper_css_class}>
                <ThemeProviderWrapper>
                <Container>
                    <Breadcrumbs keepOnMobile breadcrumbsList={breadcrumbsList}/>
                    {(asset && asset.id) && <Player userTotalVideos={totalVideos} enableDetails={true} asset={asset}/>}
                    <Box my={2}>
                        <Typography variant={'h4'}>More by {TVSite?.channelVideosData?.asset?.owner?.first_name}</Typography>
                    </Box>
                </Container>

                <Grid
                    fetchAssets={this.fetchAssets.bind(this)}
                    filters={{
                        creator_id: creator_id
                    }}
                    gridItemProps={{
                        maxDescriptionLines: 2,
                        redirect: true,
                        lazyLoadingThumbnails: true
                    }}
                    noResultsText="No videos found."
                />
                </ThemeProviderWrapper>
            </div>
        );
    }
};

let root = null;
let isMounted = false;
const targetEl = document.getElementById("app-container");

function isVideoRoute() {
    const subFolder = ConfigurationHelper.getGlobalConfiguration().sub_folder || '';
    const pathname = window.location.pathname.toLowerCase();
    // Ensure subFolder starts with / if present
    const prefix = subFolder ? (subFolder.startsWith('/') ? subFolder : '/' + subFolder) : '';

     // Allow rendering on localhost or site.<env>.tvpage.com (env = test|stage|app)
    const host = window.location.hostname;
    const envPattern = /^site\.(test|stage|app)\.tvpage\.com$/;
    const isAllowedHost = host === 'localhost' || envPattern.test(host);

    return pathname.startsWith(`${prefix}/v/`) || isAllowedHost;
}

function mountVideoApp() {
    if (!isMounted && isVideoRoute()) {
        if (targetEl) {
            root = createRoot(targetEl);
            root.render(<Video/>);
            isMounted = true;
        }
    }
}

function unmountVideoApp() {
    if (isMounted && root) {
        root.unmount();
        if (targetEl) targetEl.innerHTML = '';
        isMounted = false;
    }
}

function handleRouteChange() {
    if (isVideoRoute()) {
        mountVideoApp();
    } else {
        unmountVideoApp();
    }
}

const _pushState = history.pushState;
history.pushState = function() {
    _pushState.apply(this, arguments);
    handleRouteChange();
};
const _replaceState = history.replaceState;
history.replaceState = function() {
    _replaceState.apply(this, arguments);
    handleRouteChange();
};

window.addEventListener('popstate', handleRouteChange);
window.addEventListener('hashchange', handleRouteChange);

// Initial mount if on video route
if (isVideoRoute()) {
    mountVideoApp();
} else {
    unmountVideoApp();
}
